import type { PaymentMethodsConfig } from '../default/payment';
import type { DeepPartial } from '../default/types';

export const paymentMethodsConfig: DeepPartial<PaymentMethodsConfig> = {
  paymentMethods: {
    imageBased: ['paypal', 'mastercard', 'visa', 'diners', 'discover'],
    textBased: ['invoice', 'flexikonto'],
  },
};
